// extracted by mini-css-extract-plugin
export var right = "index-module--right--2r-wg";
export var projectImage = "index-module--project-image--frkhx";
export var projectImageDesc = "index-module--project-image-desc--Tv7Ub";